import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/share/forward.svg';

const ForwardIcon = (props) => (
   <Icon { ...props }/>
);

export default ForwardIcon;
